import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from "react";
import ReactDOM from "react-dom";
import "./styles/carbon-components.css";
import "./styles/index.css";
import "./styles/css/AdminLTE.css";
import { App } from "./components/App";
import * as serviceWorker from "./serviceWorker";

import { Provider } from "react-redux";
import { store } from "./_helpers";

import "./fonts/proximanova-regular-webfont.woff2";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
